export default "__VITE_ASSET__BTjkhk8F__"